import { formatDate } from 'date-fns'
import { z } from 'zod'

export const zDateString = z
  .string()
  .regex(/^\d{2}\.\d{2}\.\d{4}$/, 'Дата должна быть в формате ДД.ММ.ГГГГ')
  .refine(
    (dateString) => {
      const [dayStr, monthStr, yearStr] = dateString.split('.')
      const day = Number(dayStr)
      const month = Number(monthStr)
      const year = Number(yearStr)

      const date = new Date(year, month - 1, day)

      return (
        !isNaN(date.getTime()) && date.getDate() === day && date.getMonth() + 1 === month && date.getFullYear() === year
      )
    },
    {
      message: 'Недопустимая дата',
    }
  )
  .describe('Дата в формате ДД.ММ.ГГГГ')
export const zDateStringOrEmpty = z.union([zDateString, z.literal('')])

export const parseDateString = (dateString: string) => {
  const [dayString, monthString, yearString] = dateString.split('.')
  const day = Number(dayString)
  const month = Number(monthString)
  const year = Number(yearString)
  const date = new Date(year, month - 1, day)
  return {
    date,
    day,
    month,
    year,
  }
}

export const getOldestOfDateStrings = (dateStrings: Array<string | null | undefined>) => {
  if (!dateStrings.length) {
    return ''
  }
  const filteredDateStrings = dateStrings.filter(Boolean) as string[]
  try {
    const dates = filteredDateStrings.map(parseDateString)
    const oldestDate = dates.reduce((acc, date) => {
      return date.date < acc.date ? date : acc
    })
    const oldestDateString = formatDate(oldestDate.date, 'dd.MM.yyyy')
    return oldestDateString
  } catch (error) {
    return ''
  }
}
